module.exports = __webpack_public_path__ + "static/media/slide1.84db8b90.webp";